module.exports = __webpack_public_path__ + "img/green-check.bb9d9830.svg";